<template>
    <div class="row no-gutters historical-batch-container">
        <div class="col-3 dmv-text text-center pt-4 historical-batch-information">
            <span class="dmv-text-secondary">{{resource('DmVisualizer_ScenarioHistoricalOverview_Period_Label')}}:</span>
            <br />
            <span>{{formattedFrom}}</span>
            <br />
            -
            <br />
            <span>{{formattedTo}}</span>

            <br />
            <br />

            <span class="dmv-text-secondary">{{resource('DmVisualizer_ScenarioHistoricalOverview_TargetDate_Label')}}:</span>
            <br />
            <span>{{formattedTarget}}</span>
            
            <br />
            <br />
            
            <span class="fa fa-bar-chart-o fa-3x"></span>
            <br />
            <a class="dmv-text dmv-link dmv-text-secondary" :href="dashboardUrl">{{resource('DmVisualizer_ScenarioHistoricalOverview_DashboardLink_Label')}}</a>
        </div>
        <div class="col border historical-batch-table-container">
            <table class="table table-striped historical-batch-table">
                <thead>
                <tr>
                    <th colspan="2">&nbsp;</th>
                    <th>{{resource('DmvHistoricalBatchListModel_Costs_DisplayName')}}</th>
                    <th>{{resource('DmvHistoricalBatchListModel_Recipients_DisplayName')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr 
                    v-for="scenario in sortedScenarios"
                    :key="scenario.scenarioId"
                >
                    <td>
                        <span class="dmv-text dmv-text-secondary">{{scenario.name}}</span>
                        <br />
                        <div class="scenario-image-container">
                            <img v-if="scenario.imageUrl" v-bind:src="scenario.imageUrl" class="scenario-image" />
                        </div>
                    </td>
                    <td>&nbsp;</td>
                    <td><span class="dmv-text dmv-text-primary">&euro; {{aggregatedScenarioValues[scenario.scenarioId].costs}}</span></td>
                    <td><span class="dmv-text dmv-text-primary dmv-text-medium-large text-bold">{{aggregatedScenarioValues[scenario.scenarioId].recipients}}</span></td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td>&nbsp;</td>
                    <td><span class="dmv-text dmv-text-large dmv-text-primary">{{resource('DmVisualizer_ScenarioHistoricalOverview_Totals_Label')}}</span></td>
                    <td><span class="dmv-text dmv-text-medium-large dmv-text-primary">&euro; {{totalCosts}}</span></td>
                    <td><span class="dmv-text dmv-text-large dmv-text-primary text-bold">{{totalRecipients}}</span></td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import dmVisualizerApi from '@core/Api/dm-visualizer';

    import sortScenariosMixin from '../../Mixins/sort-scenarios-mixin';
    import formatDateMixin from '../../Mixins/format-date-mixin';
    import resourceMixin from '../../../../Util/Mixins/resources';
    
    import _ from 'lodash';
    
    export default {
        name: "historical-scenario-list",
        mixins: [sortScenariosMixin, resourceMixin, formatDateMixin],

        props: {
            fromDate: {
                type: [Date, String],
                required: true
            },
            toDate: {
                type: [Date, String],
                required: true
            },
            targetDate: {
                type: [Date, String],
                required: true
            },
            scenarioBatches: {
                type: Array,
                required: true
            }
        },
        
        computed: {
            dashboardUrl() {
                return dmVisualizerApi.formatDashboardUrl();
            },
            
            sortedScenarios(){
                //Take the first record per scenario id
                const uniqueScenarios = _.uniqBy(this.scenarioBatches, 'scenarioId');
                
                return this.sortScenarios(uniqueScenarios);
            },
            
            aggregatedScenarioValues(){
                const scenarioGroupings = _.groupBy(this.scenarioBatches, 'scenarioId');

                //Aggregate costs/recipients per scenario id
                return Object.keys(scenarioGroupings).reduce((aggregations, scenarioId) => {
                    aggregations[scenarioId] = {
                        costs: _.sumBy(scenarioGroupings[scenarioId], 'costs'),
                        recipients: _.sumBy(scenarioGroupings[scenarioId], 'recipients')
                    };

                    return aggregations;
                }, {});
            },
            
            formattedFrom(){
                return this.formatDate(this.fromDate);
            },
            
            formattedTo(){
                return this.formatDate(this.toDate);
            },
            
            formattedTarget(){
                return this.formatDate(this.targetDate);
            },
            
            totalCosts(){
                return _.sumBy(this.scenarioBatches, 'costs');
            },
            
            totalRecipients(){
                return _.sumBy(this.scenarioBatches, 'recipients');
            }
        }
    };
</script>

<style scoped src="../../Style/scenario-historical-overview.scss" lang="scss">

</style>
